import { Orientation } from '../types';
export var getZeroIntersectionVisibility = function (layout, xScale, yScale, enabledGridX, enabledGridY) {
    var verticalLayout = layout === Orientation.VERTICAL;
    var scaleDomain = verticalLayout ? yScale.domain() : xScale.domain();
    var isVisible = scaleDomain[0] < 0 && scaleDomain[1] > 0;
    var enabled = verticalLayout ? enabledGridY : enabledGridX;
    return isVisible && enabled;
};
export var calculateZeroIntersection = function (layout, xScale, yScale, dimensions, margins) {
    var verticalLayout = layout === Orientation.VERTICAL;
    var scale = verticalLayout ? yScale : xScale;
    if (verticalLayout)
        return {
            x1: margins.left,
            y1: scale(0),
            x2: dimensions.width - margins.right,
            y2: scale(0),
        };
    return {
        x1: scale(0),
        y1: margins.top,
        x2: scale(0),
        y2: dimensions.height - margins.bottom,
    };
};
